import React, { useState } from 'react';

import { Divider, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { AthleteKiloClassWithAthlete } from 'types';

import LateCancelNoShowAthletesClasses from './components/LateCancelAndNoShowAthletesClasses';
import ModalAthleteClassDelete from '../ModalAthleteClassDelete';

interface ILateCancelAthletesProps {
  athleteKiloClasses: AthleteKiloClassWithAthlete[];
  permission?: boolean;
}

const LateCancelAndNoShowAthletesClasses = ({
  athleteKiloClasses,
  permission = true,
}: ILateCancelAthletesProps): JSX.Element => {
  const [athleteKiloClassId, setAthleteKiloClassId] = useState<string>('');
  const [deleteModalOpened, { open: openDeleteModal, close: closeDeleteModal }] = useDisclosure(false);

  const handleDeleteModal = (id: string): void => {
    setAthleteKiloClassId(id);
    openDeleteModal();
  };
  if (athleteKiloClasses.length) {
    return (
      <>
        <Stack spacing={0} pt='xs'>
          {athleteKiloClasses.map((akc, index) => {
            return (
              <LateCancelNoShowAthletesClasses
                athleteKiloClass={akc}
                permission={permission}
                index={index}
                key={index}
                handleDeleteModal={handleDeleteModal}
              />
            );
          })}
          <Divider />
        </Stack>
        <ModalAthleteClassDelete
          opened={deleteModalOpened}
          handleClose={closeDeleteModal}
          athleteKiloClassId={athleteKiloClassId}
        />
      </>
    );
  }
  return (
    <Group position='center'>
      <Text color='dimmed'>No athletes to display</Text>
    </Group>
  );
};

export default LateCancelAndNoShowAthletesClasses;
